import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SessionService {

    public getBearerToken() {
        if (localStorage.getItem('T120')) {
            return atob(localStorage.getItem('T120'));
        } else {
            return null;
        }
    }

    public setBearerToken(token) {
        return localStorage.setItem('T120', btoa(token));
    }

    public setIsAdmin(isAdmin: boolean): void {
        localStorage.setItem('T110', btoa(String(isAdmin)));
    }

    public isAdmin(): boolean {
        return atob(localStorage.getItem('T110')) === 'true';
    }
}
